module.exports = __webpack_public_path__ + "static/media/contactsGreen.37688bec.svg";